import { render, staticRenderFns } from "./browse-asset-modal.vue?vue&type=template&id=ff445042&scoped=true&"
import script from "./browse-asset-modal.vue?vue&type=script&lang=ts&"
export * from "./browse-asset-modal.vue?vue&type=script&lang=ts&"
import style0 from "./browse-asset-modal.vue?vue&type=style&index=0&id=ff445042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff445042",
  null
  
)

export default component.exports